import { NgModule } from '@angular/core';

import { DepoimentoComponent } from './depoimento.component';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        DepoimentoComponent
    ],
    imports: [
        TranslateModule,
        CommonModule
    ],
    exports: [
        DepoimentoComponent
    ]
})

export class DepoimentoModule { }
